import Icon from '../icon/Icon';
import Label from '../label/Label';

import theme from '../../../themes/colors';

interface LabelledNumberStepperProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  minValue?: number;
  maxValue?: number;
  isRequired?: boolean;
  className?: string;
  labelClassName?: string;
  stepperClassName?: string;
  optionalText?: string;
  disabled?: boolean;
}

const LabelledNumberStepper = ({
  label,
  value,
  onChange,
  minValue,
  maxValue,
  isRequired,
  className,
  labelClassName,
  stepperClassName,
  optionalText,
  disabled = false
}: LabelledNumberStepperProps) => {
  const resolvedMin = minValue ?? -Infinity;
  const resolvedMax = maxValue ?? Infinity;
  const decrementDisabled = disabled || value <= resolvedMin;
  const incrementDisabled = disabled || value >= resolvedMax;

  const minusStroke = decrementDisabled ? theme.grey60 : theme.cofeeNeutral10;
  const plusStroke = incrementDisabled ? theme.grey60 : theme.cofeeGreen6;

  return (
    <div className={className}>
      <Label
        label={label}
        isRequired={isRequired}
        optionalText={optionalText}
        className={`!mb-2 !text-cofeeNeutral10 ${labelClassName || ''}`}
      />
      <div
        className={`flex h-12 w-1/3 divide-x divide-cofeeNeutral4
          overflow-hidden rounded-lg border border-cofeeNeutral4 bg-cofeeNeutral1
          ${stepperClassName || ''}`}
        role="group"
        aria-label={label}
      >
        <button
          type="button"
          className="flex flex-1 items-center justify-center hover:bg-cofeeNeutral2
           disabled:cursor-not-allowed"
          aria-label={`Decrease ${label}`}
          disabled={decrementDisabled}
          onClick={() => onChange(value - 1)}
        >
          <Icon name="minus" size="16" stroke={minusStroke} />
        </button>
        <div
          className="flex flex-1 items-center justify-center text-base
            font-bold text-cofeeNeutral10"
        >
          {value}
        </div>
        <button
          type="button"
          className="flex flex-1 items-center justify-center hover:bg-cofeeNeutral2 disabled:cursor-not-allowed"
          aria-label={`Increase ${label}`}
          disabled={incrementDisabled}
          onClick={() => onChange(value + 1)}
        >
          <Icon name="plus" size="16" stroke={plusStroke} />
        </button>
      </div>
    </div>
  );
};

export default LabelledNumberStepper;
